import React from 'react';
import { Badge, BadgeType } from '../../../../../../components/badge/badge';
import Section from './section';
import DefaultVsResolvedTable from './default-vs-resolved-table';
import { humanizeValue, valuesAreEqual } from '../../profile-explanation-utils';

interface IResultSectionProps {
    result: unknown;
    defaultValue: unknown;
}

const ResultSection: React.FC<IResultSectionProps> = ({ result, defaultValue }) => {
    const isResultObject = result !== null && typeof result === 'object' && !Array.isArray(result);

    const titleExtra = isResultObject ? (() => {
        const defaultObj = (defaultValue as Record<string, unknown>) ?? {};
        const resolvedObj = (result as Record<string, unknown>) ?? {};
        const allKeys = Array.from(new Set([...Object.keys(defaultObj), ...Object.keys(resolvedObj)]));
        const changedCount = allKeys.filter((k) => {
            const dVal = k in defaultObj ? defaultObj[k] : undefined;
            const rVal = k in resolvedObj ? resolvedObj[k] : undefined;
            return !valuesAreEqual(dVal, rVal);
        }).length;
        return changedCount > 0 ? (
            <Badge type={BadgeType.INFO} text={`${changedCount} of ${allKeys.length} properties changed`} />
        ) : null;
    })() : null;

    return (
        <Section title="Result" titleExtra={titleExtra}>
            {isResultObject ? (
                <DefaultVsResolvedTable
                    defaultData={(defaultValue as Record<string, unknown>) ?? {}}
                    resolvedData={(result as Record<string, unknown>) ?? {}}
                />
            ) : (
                <div className="profile-explanation-scalar-result">
                    <span className="profile-explanation-label">Computed value</span>
                    <span className="profile-explanation-scalar-value">{humanizeValue(result)}</span>
                </div>
            )}
        </Section>
    );
};

export default ResultSection;
